import React from "react";

const ApporvalLetter = () => {
  return (
    <div className="approv_letter_sec">
      <div className="row">
        <div className="col-12">
          <div className="qep_grad mt-4">
            <h2>Approval Letters</h2>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="mb-3">
            <label className="form-label">Start Date of Approval</label>
            <input
              type="date"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Start Date of Approval"
            />
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="mb-3">
            <label className="form-label">End Date of Approval</label>
            <input
              type="date"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Start Date of Approval"
            />
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="mb-3">
            <label className="form-label">Upload Approval Letter (PDF)</label>
            <input
              type="file"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Start Date of Approval"
            />
          </div>
        </div>
        <div className="col-12">
          <div className="common_card">
            <div className="qep_grad mt-0">
              <h2>List of Approval Letters</h2>
            </div>
            <div className="table-responsive p-0">
              <table className="common_table table">
                <thead>
                  <tr>
                    <th>Start Date of Approval</th>
                    <th>End Date of Approval</th>
                    <th>Approval Letter</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>2025-01-01</td>
                    <td>2025-03-01</td>
                    <td>Completed</td>
                  </tr>
                  <tr>
                    <td>2025-01-01</td>
                    <td>2025-03-01</td>
                    <td>04/20/2025</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApporvalLetter;
